import apiClient from './client';

/** Matches portal `currencyApi` — countries table for onboarding entity selects. */
export interface CountryListItem {
  id: string;
  code: string;
  name: string;
  phoneCode: string | null;
  currencyCode: string | null;
  isActive: boolean;
}

export const currencyCountriesApi = {
  getCountries: () => apiClient.get<CountryListItem[]>('/Currency/get-counties'),
};
